<div class="summary-container">
  @if (isLoading) {
    <div class="loading-container">
      <app-loader [size]="'big'"></app-loader>
    </div>
  }

  @if (appSumm === "" && !isLoading) {
    <div class="no-summary">
      <img src="assets/imgs/undraw/undraw_no_data.svg" alt="Nessun Riassunto" />
      <span>Nessun Riassunto generato</span>
    </div>
  }

  @if (appSumm !== "" && !isLoading) {
    @if (!isEditing) {
      <div class="text-summary" [innerHTML]="appSumm"></div>
    }
    @if (isEditing) {
      <textarea
        class="markdown-editor"
        [(ngModel)]="markdownContent"
        (input)="onMarkdownChange($event)"
        placeholder="Edit your summary in Markdown..."
      ></textarea>
    }
  }
</div>
